// extracted by mini-css-extract-plugin
export default {"label":"checkin_details_label__rVfhB"};